<template>
  <div>
    <v-row>
      <v-col md="12">
        <project-list />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProjectList from '@/components/constructionProjects/ProjectList.vue';

export default {
  name: 'ConstructionProjectsOverview',
  components: {
    ProjectList
  },
  data: () => ({}),
  computed: {},
  watch: {},
  mounted() {
    // this.getAddresses();
  },
  methods: {}
};
</script>
<style lang="scss" scoped></style>
